export default "__VITE_ASSET__CxZIxdDe__"